import React from 'react'
import Grid from 'atoms/layout/Grid'
import PageList from 'data/pages.json'
import ButtonLink from 'atoms/navigation/ButtonLink'
import Container from 'atoms/layout/Container'
import Box from 'atoms/layout/Box'
import Typography from 'atoms/display/Typography'
import NoWrap from 'atoms/display/NoWrap'

export default function Header () {
  return (
    <header>
      <Box my={4}>
        <Container>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid container item xs={12} sm={4} md={3}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  <NoWrap>広島大学</NoWrap>
                  <NoWrap>大学院理学研究科</NoWrap>
                  <NoWrap>数理分子生命理学専攻</NoWrap>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <ButtonLink to="/">
                    <Typography variant="h5">
                      <NoWrap>自己組織化学</NoWrap><NoWrap>研究室</NoWrap>
                    </Typography>
                  </ButtonLink>
                </Typography>
              </Grid>
            </Grid>
            <Grid container item xs={12} sm={8} md={9} justify="center">
              {PageList.filter(v => v.path !== '').map(v => (
                <Grid
                  key={`path-${v.path}`}
                  item
                  md={3}
                  sm={4}
                  xs={12}
                >
                  <ButtonLink to={v.path} fullWidth>
                    {v.name}
                  </ButtonLink>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Container>
      </Box>
    </header>
  )
}
